module.exports = __webpack_public_path__ + "static/media/video.c1bfd26d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/video.mp4
// module id = 895
// module chunks = 5